import { render } from "./AccessLandControl.vue?vue&type=template&id=58dd3c2a&ts=true"
import script from "./AccessLandControl.vue?vue&type=script&lang=ts"
export * from "./AccessLandControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__